<template>
    <v-dialog v-model="assetCarousel" persistent>
        <v-card elevation="0" color="black">
            <v-card-actions class="py-0 my-0">
                <v-spacer/>
                <p class="text-right py-0 my-0">
                    <v-btn fab text large>
                        <v-icon large color="white" @click="close">close</v-icon>
                    </v-btn>
                </p>
            </v-card-actions>
            <v-card-text class="my-0 py-0">
                <v-container fluid class="pb-0 mb-0">
                    <v-row align="center" justify="center">
                        <v-col cols="2" class="ma-0 pa-0">
                            <p class="text-left">
                                <v-btn v-if="selectedIndex != 0" fab text large @click="previous">
                                    <v-icon large color="white">arrow_back_ios</v-icon>
                                </v-btn>
                            </p>
                        </v-col>
                        <v-col cols="8">
                            <div v-if="selectedIndex >=0">
                                <p v-if="assets[selectedIndex].type =='image'" class="text-center pa-0 ma-0">
                                    <v-img contain height="500" :src="assets[selectedIndex].url"></v-img>
                                </p>
                                <v-responsive v-if="assets[selectedIndex].type =='video'" class="pa-0 ma-0"  height="500">
                                    <v-container fill-height fluid class="pa-0 ma-0">
                                    <v-row align="center"
                                        justify="center"
                                        class="pa-0 ma-0"
                                    >
                                        <v-col
                                            class="pa-0 ma-0"
                                        >
                                            <d-player 
                                            :options="{ video: { url: assets[selectedIndex].url, pic: ''},}"
                                            :ref="`player-${selectedIndex}`"
                                        >
                                        </d-player>
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-responsive>
                            </div>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                            <p class="text-right">
                                <v-btn v-if="selectedIndex != assets.length - 1" fab text large @click="next">
                                    <v-icon large color="white">arrow_forward_ios</v-icon>
                                </v-btn>
                            </p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="py-0 my-0">
                <v-spacer/>
                <p class="text-right py-0 my-0">
                    <v-btn disabled fab text large>
                        <v-icon large></v-icon>
                    </v-btn>
                </p>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'
export default {
    name: 'LightBox',
    props: {
        assets: {
            type: Array,
            default: [],
        }
    },
    components: {
        'd-player': VueDPlayer,
    },
    data() {
        return {
            assetCarousel: false,
            selectedIndex: 0
        };
    },
    methods: {
        show(index) {
            console.log(index);
            this.selectedIndex = index;
            this.assetCarousel = true;
        },
        close() {
            this.assetCarousel = false;
            this.selectedIndex = - 1;
        },
        next() {
            if(this.selectedIndex < this.assets.length - 1) {
                this.selectedIndex = this.selectedIndex + 1;
            }
        },
        previous() {
            if(this.selectedIndex > 0) {
                this.selectedIndex = this.selectedIndex - 1;
            }
        },
    }


}
</script>